module.exports = hardBreak;

function hardBreak() {
  return '\\\n';
}